import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import NoRecords from './NoRecords';
import UserCard from './UserCard';

import AuthContext from 'providers/auth';
import UserApi from 'api/user';
import AlertHelper from 'helpers/AlertHelper';
import withContentLoader from 'components/ui/withContentLoader';
import { useTranslation } from 'react-i18next';

const UserList = ({ data = [] }) => {
  const context = useContext(AuthContext);
  const { id: company_id } = context.me.company;

  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutationParams = {
    onSuccess: () => {
      queryClient.invalidateQueries('users');
    },
  };

  const deleteMutation = useMutation(id => UserApi.delete(id), mutationParams);
  const toggleAdminMutation = useMutation(({ id, is_admin }) => UserApi.toggleAdmin(id, company_id, is_admin), mutationParams);

  if (!data.length) {
    return <NoRecords />;
  }

  const onRemoveUser = async user => {
    const result = await AlertHelper.confirmDanger({
      title: t('components.users.actions.remove'),
      html: t('components.users.confirmations.remove', { name: user.name }),
    });

    if (result.value) {
      deleteMutation.mutate(user.id);
    }
  };

  const onToggleAdmin = async user => {
    const { is_admin } = user.companies.find(company => company.id === company_id).UserCompany;
    const alertType = is_admin ? 'confirmDanger' : 'confirm';
    const type = is_admin ? 'remove_admin' : 'make_admin';

    const result = await AlertHelper[alertType]({
      title: t(`components.users.actions.${type}`),
      html: t(`components.users.confirmations.${type}`, { name: user.name }),
    });

    if (result.value) {
      toggleAdminMutation.mutate({ id: user.id, is_admin: !is_admin });
    }
  };

  const users = data.map(user => {
    return (
      <div className="col-md-3 mb-3">
        <UserCard {...user} remove={onRemoveUser.bind(this, user)} toggleAdmin={onToggleAdmin.bind(this, user)} key={user.id} />
      </div>
    );
  });

  return <div className="row">{users}</div>;
};

const fetchData = async () => UserApi.fetch();
export default withContentLoader(UserList, { name: 'users', fetchData });
